import React from 'react';
import { Cushion, MaxWidth, Typography } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const NoStatsPlaceholder = () => (
  <Cushion horizontal="large" vertical="xxxlarge">
    <Typography preset="body--large" color="dustygrey" align="center" component="div">
      <MaxWidth component="div" maxWidth={280} center>
        <Trans i18nKey="teams:statistics_no_stats_placeholder">
          Looks like no matches have been played this season.
        </Trans>
      </MaxWidth>
    </Typography>
  </Cushion>
);

export default NoStatsPlaceholder;
